"use strict";

const cpf = require('./lib/cpf');

module.exports = cpf;
